var _linearGradient, _linearGradient2, _linearGradient3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsAutomationCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DevOpsAutomationCode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "44e5kb8bxa",
    x1: -1203.011,
    y1: -5680.009,
    x2: -1196.011,
    y2: -5680.009,
    gradientTransform: "translate(1227.502 5697.519)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7h2j5f119b",
    x1: -1203.011,
    y1: -6897.07,
    x2: -1196.011,
    y2: -6897.07,
    gradientTransform: "matrix(1 0 0 -1 1203.503 -6879.56)",
    xlinkHref: "#44e5kb8bxa"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aeu35mtq3d",
    x1: 0,
    y1: 32,
    x2: 32,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a56eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0f62fe"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "9ebwtxb2fc",
    x: -0.008,
    y: 0,
    width: 32.008,
    height: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.99 19.018V25.01h-2v2h2c1.103 0 2-.897 2-2v-5.992c0-1.103.897-2 2-2v-2c-2.206 0-4 1.794-4 4z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 27.992 17.51)",
    style: {
      fill: "url(#44e5kb8bxa)",
      strokeWidth: 0
    },
    d: "M24.491 13.511h7v8h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.991 13.003V7.011c0-1.122-.879-2-2-2h-2v2h2v5.992c0 2.206 1.794 4 4 4v-2c-1.103 0-2-.897-2-2z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.991 25.011V19.019c0-2.206-1.794-4-4-4v2c1.103 0 2 .897 2 2v5.992c0 1.103.897 2 2 2h2v-2h-2z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 3.993 17.51)",
    style: {
      fill: "url(#7h2j5f119b)",
      strokeWidth: 0
    },
    d: "M.492 13.511h7v8h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.991 7.011v-2h-2c-1.103 0-2 .897-2 2v5.992c0 1.103-.897 2-2 2v2c2.206 0 4-1.794 4-4V7.011h2z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#9ebwtxb2fc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#aeu35mtq3d)",
      strokeWidth: 0
    },
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001d6c",
      strokeWidth: 0
    },
    d: "M13.985 10.006h9v2h-9zM8.986 10.006h3v2h-3zM8.986 15.005h3v2h-3zM8.986 19.995h3v2h-3zM13.982 19.995h9v2h-9zM13.982 15.005h9v2h-9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsAutomationCode);
export default __webpack_public_path__ + "static/media/DevOpsAutomationCode.52eecebc3191115f1ca29dcfd7e73fff.svg";
export { ForwardRef as ReactComponent };